import { Injectable } from '@angular/core'; 
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/timeout';
import { throwError as observableThrowError, Observable } from 'rxjs';
// import {
//     Http, RequestOptions,
//     RequestOptionsArgs, Response,
//     Request, Headers, XHRBackend
// } from '@angular/http';
import { HttpClient, HttpHandler, HttpHeaders } from '@angular/common/http';
import { element } from '@angular/core/src/render3';
import { catchError, tap, finalize } from 'rxjs/operators';

// import { AngularReduxRequestOptions } from './angular-redux-request.options';
// import { LoaderService } from './loader/loader.service';
// import { TimeOutService } from './timeOut/timeOut.service';
// import { Logger as Loggerr } from '../core/logger/logger';
// import { Log, Level } from 'ng2-logger'



// const httpOptions = {
//     headers: new HttpHeaders(
//         {
//             'authorization': 'Basic aW5zaWdodHNlcnZpY2U6TXBzSW5zaWdodA==',
//             'Content-Type': 'application/x-www-form-urlencoded',
//         }
//     )

// };

@Injectable()
export class HttpService {
    post: any;


    constructor(
        private http: HttpClient
        // ,
        // //        private handler: HttpHandler,
        // // backend: XHRBackend,
        // // defaultOptions: AngularReduxRequestOptions,
        // private loaderService: LoaderService,
        // private timeOutService: TimeOutService,
        // private logger: Loggerr
    ) {

        // super(handler);
        //        super(backend, defaultOptions);
        //   console.log('http service');
    }


    getData(url: string, tokenId: any, responseType: string = 'json'): Observable<any> {


        this.showLoader();

        let options: any;

     //   if(isquery){
        options = this.getHTTPOptionQuery(tokenId);
         //    }
         //   else{
           //   options = this.getHTTPOption(tokenId);
           //  }
       
        // console.log(this.http);

       // console.log(url, body);
        options['responseType'] = responseType;


        return this.http.get(url)
              .map((response: any) => response)
              .catch(this.onCatch);
  }




  extractPostData(url: string, body: any, tokenId: any, responseType: string = 'json',isjsonheader:boolean=false): Observable<any> {
    this.showLoader();

    // console.log('Data',body);
    let options;
    if(isjsonheader){
           options = this.getHTTPOptionjsonHeader(tokenId);
       }else{

            options = this.getHTTPOption(tokenId);
       }
    // console.log(this.http);
    options['responseType'] = responseType;
    return this.http.post(url, body, options).pipe(
          catchError(this.onCatch),
          tap((res: Response) => {
                //   console.log(res);
                this.onSuccess(res);

          }, (error: any) => {
                // console.log('error');
                this.onError(error);
          }),
          finalize(() => {
                // console.log('final.......................................................');
                this.onEnd();
          }));

}
    /*
        downloadFile(url: string, body: any, options?: RequestOptionsArgs){

            return super.post(url, body, this.requestOptions(options))
                // return super.get(url, body)
                .catch(this.onCatch)
                .do((res: Response) => {
                    console.log(res);
                    this.onSuccess(res);
                }, (error: any) => {
                    this.onError(error);
                })
                .finally(() => {
                    this.onEnd();
                });

            super.get().subscribe(data => this.downloadFile(data)),//console.log(data),
                     error => console.log("Error downloading the file."),
                     () => console.info("OK")
        }


        downloadDataFile(data: Response){
            var blob = new Blob([data], { type: 'text/xls' }
            var url= window.URL.createObjectURL(blob);
            window.open(url);
        }
    */    addToFormData(formData: FormData, obj: any) {
        Object.keys(obj)
            .forEach((key) => {
                formData.append(key, obj[key]);
            });
    }

    upLoadOptions(tokenId: string) {
        let headers = new HttpHeaders();
        //  head.append('enctype', 'multipart/form-data');
        headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
        // headers = headers.set('enctype', 'application/x-www-form-urlencoded');
        const httpOptions = {
            headers: headers
        };

        if (tokenId) {
            httpOptions.headers = httpOptions.headers.set('token', tokenId);
        }
        return httpOptions;
    }

    // uploadData(event: any, urlStr: string, formName: string, otherBody: any = {}, tokenId: any) {

    //     const fileList: FileList = event.target.files;
    //     if (fileList.length > 0) {
    //         const file: File = fileList[0];
    //         const formData: FormData = new FormData();
    //         formData.append('file', file, file.name);
    //         // formData.append('podXML', '1');
    //         this.addToFormData(formData, otherBody);


    //         const options = this.upLoadOptions(tokenId);
    //         options['responseType'] = 'text';

    //         return this.http.post(urlStr, formData, options);

    //     }
    // }

    // private requestOptions(options?: RequestOptionsArgs): RequestOptionsArgs {

    //     if (options == null) {
    //         options = new AngularReduxRequestOptions(null);
    //     }
    //     //    console.log(options);

    //     return options;
    // }

    private onCatch(error: any, caught: Observable<any>): Observable<any> {
        // console.log('Catch, error: ', error);
        return observableThrowError(error);
    }

    private onSuccess(res: Response): void {
        //    console.log('Request successful');
        // console.log(res);
    }

    private onError(res: Response): void {
        // console.log('Error, status code: ' + res.status);
    }

    private onEnd(): void {
        this.hideLoader();
    }

    private showLoader(): void {
        //    console.log('called showLoader');
        //    this.loaderService.show();
    }

    private hideLoader(): void {
        //    console.log('called hideLoader');
        //    this.loaderService.hide();
    }


    


    private getHTTPOptionjsonHeader(tokenId: any): any {
        const httpOptions = {
            headers: new HttpHeaders(
                {
                    
                    // 'authorization': 'Basic aW5zaWdodHNlcnZpY2U6TXBzSW5zaWdodA==',
                   //  'Content-Type': 'application/x-www-form-urlencoded'
                    'Content-Type': 'application/json'
                }
            )
        };
        if (tokenId) {
            httpOptions.headers = httpOptions.headers.set('Authorization','Bearer '+ tokenId);
      }
        return httpOptions;
    }




    private getHTTPOptionQuery(tokenId: any): any {
        const httpOptions = {
            headers: new HttpHeaders(
                {
                    
                    // 'authorization': 'Basic aW5zaWdodHNlcnZpY2U6TXBzSW5zaWdodA==',
                     'Content-Type': 'application/x-www-form-urlencoded'
                  //  'Content-Type': 'application/json'
                }
            )
        };
        if (tokenId) {
            httpOptions.headers = httpOptions.headers.set('Authorization','Bearer '+ tokenId);
      }
        return httpOptions;
    }





    private getHTTPOption(tokenId: any): any {
        const httpOptions = {
            headers: new HttpHeaders(
                {
                    // 'authorization': 'Basic aW5zaWdodHNlcnZpY2U6TXBzSW5zaWdodA==',
                   'Content-Type': 'application/x-www-form-urlencoded' 
                  //  'Content-Type': 'application/json'
                }
            )
            
         //   , observe:'response'
             
            
        };
        
      //  httpOptions.set('observe','response');

        if (tokenId) {
           // httpOptions.headers = httpOptions.headers.set('token', tokenId);
            httpOptions.headers = httpOptions.headers.set('Authorization','Bearer '+ tokenId);
        }
        return httpOptions;
    }

}
